import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTimeBox from '@/components/DdTimeBox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdDropDown from '@/components/DdDropDown'
import DdDataTable from '@/components/DdDataTable'
import DdEditDialog from '@/components/DdEditDialog'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButton from '@/components/DdIconButton'

import ThNippoNoTextBox from '@/components/ThNippoNoTextBox'
import ThNippoKamotsuSearchButton from '@/components/ThNippoKamotsuSearchButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import complements from '@/rahmen/complement'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'
import dolly from '@/rahmen/utils/dolly'
import tax from '@/ddv2.library/tax'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

import dayjs from 'dayjs'

export default {
  name: 'THPRMD0010',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdTimeBox,
    DdCodeTextBox,
    DdNumericBox,
    DdRadioButton,
    DdDropDown,
    DdDataTable,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDefaultButton,
    DdFooterButton,
    DdIconButton,
    ThNippoNoTextBox,
    ThNippoKamotsuSearchButton
  },
  data: () => ({
    id: 0,
    haishaKbn: '00',
    jishaSharyoSbt: '',
    yoshaSharyoSbt: '',
    invalidMessages: {},
    // ----------------------------------------------------------------------------------------------------
    // 必須制御
    // ----------------------------------------------------------------------------------------------------
    isRequiredCommon: true,
    isRequiredJomuin: false,
    isRequiredJoshu: false,
    isRequiredSharyo: false,
    isRequiredYosha: false,
    // ----------------------------------------------------------------------------------------------------
    // 権限制御
    // ----------------------------------------------------------------------------------------------------
    isReadOnlyBase: false,
    isReadOnlyCommon: false,
    isReadOnlyJisha: false,
    isReadOnlyYosha: false,
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    viewsData: {
      vwUnkoJisseki: {},
      vwKintaiJissekiJomuin: {},
      vwKintaiJissekiJoshu: {},
      vwHaisoMeisai: [{}],
      vwSharyoKeihiNenryohi: [{}],
      vwSharyoKeihiTsukoryo: [{}]
    },
    /*
     * 編集情報取得キー定義
     */
    conditions: {
      digitakoUnkoId: ''
    },
    /*
     * 配送明細編集用定義
     */
    recHaisoMeisai: {},
    recHaisoMeisaiDefault: {
      id: -1,
      kaishaCd: null,
      trUnkoJissekiId: null,
      trSagyoJissekiId: null,
      trSagyoMeisaiId: null,
      trJuchuKihonId: null,
      trJuchuMeisaiId: null,
      juchuNo: null,
      juchuEigyoshoId: null,
      ninushiId: null,
      ninushiCd: null,
      ninushiNm: null,
      hatsuchiId: null,
      hatsuchiCd: null,
      hatsuchiNm: null,
      oroshisakiId: null,
      oroshisakiCd: null,
      oroshisakiNm: null,
      chakuchiId: null,
      chakuchiCd: null,
      chakuchiNm: null,
      uriageKingaku: null,
      editFlg: null,
      delFlg: null,
      updDate: null
    },
    /*
     * 経費編集画面用定義
     */
    recNenryo: {},
    recTsukoryo: {},
    recKeihiDefault: {
      id: -1,
      trUnkoJissekiId: null,
      trSharyoKeihiId: null,
      sharyoKeihiNo: null,
      mstSharyoId: null,
      sharyoCd: null,
      torokuChimei: null,
      torokuBunruiNo: null,
      torokuHiragana: null,
      torokuIchirenShiteiNo: null,
      hasseiYmd: null,
      keijoYmd: null,
      torihikisakiId: null,
      torihikisakiCd: null,
      torihikisakiNm: null,
      sharyoSeibiKeihiKbn: null,
      fuelKbn: null,
      fuelKbnNm: null,
      suryo: null,
      sharyoSeibiTaniKbn: null,
      keihiTanka: null,
      keihiKingaku: null,
      tekiyo1: null,
      tekiyo2: null,
      tekiyo3: null,
      shiharaiKbnNm: null,
      tekiyo4: null,
      tekiyo5: null,
      delFlg: false,
      editFlg: false,
      updDate: null
    },
    // ----------------------------------------------------------------------------------------------------
    // タブ定義
    // ----------------------------------------------------------------------------------------------------
    tab: [
      { href: '#tab1', value: '配送明細' },
      { href: '#tab2', value: '燃料' },
      { href: '#tab3', value: '通行料' }
    ],
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    // ----------------------------------------------------------------------------------------------------
    // ダイアログ定義
    // ----------------------------------------------------------------------------------------------------
    nippo_search_dialog: false,
    nenryo_edit_index: -1,
    nenryo_max_index: -1,
    tsukoryo_edit_index: -1,
    tsukoryo_max_index: -1,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    copyMode: 0,
    registerMode: 0,
    modeKengen: 0,
    CancelButtonDisp: true,
    DeleteButtonDisp: false,
    NewButtonDisp: true,
    SaveButtonDisp: true,
    showCopyDialog: false,
    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    haiso_meisai_list_headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '貨物No', value: 'juchuNo' },
      { text: '営業所', value: 'wEigyoshoCdNm' },
      { text: '荷主', value: 'wNinushiCdNm' },
      { text: '発地', value: 'wHatsuchiCdNm' },
      { text: '卸先', value: 'wOroshisakiCdNm' },
      { text: '着地', value: 'wChakuchiCdNm' },
      { text: '売上金額', value: 'uriageKingaku', align: 'right' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ],
    nenryohi_list_headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: 'No', value: 'sharyoKeihiNo' },
      { text: '給油所', value: 'wTorihikisakiCdNm' },
      { text: '燃料名', value: 'wFuelKbnNm' },
      { text: '給油量', value: 'suryo', align: 'right' },
      { text: '単価', value: 'keihiTanka', align: 'right' },
      { text: '金額', value: 'keihiKingaku', align: 'right' },
      { text: '支払方法', value: 'wShiharaiKbnNm' },
      { text: 'カード番号', value: 'tekiyo4' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ],
    tsukoryo_list_headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: 'No', value: 'sharyoKeihiNo' },
      { text: '入口料金所', value: 'tekiyo1' },
      { text: '出口料金所', value: 'tekiyo2' },
      { text: '回数', value: 'suryo', align: 'right' },
      { text: '金額', value: 'keihiKingaku', align: 'right' },
      { text: '支払方法', value: 'wShiharaiKbnNm' },
      { text: 'カード番号', value: 'tekiyo4' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ],
    yosha_haiso_meisai_list_headers: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '貨物No', value: 'juchuNo' },
      { text: '営業所', value: 'wEigyoshoCdNm' },
      { text: '荷主', value: 'wNinushiCdNm' },
      { text: '発地', value: 'wHatsuchiCdNm' },
      { text: '卸先', value: 'wOroshisakiCdNm' },
      { text: '着地', value: 'wChakuchiCdNm' },
      { text: '売上金額', value: 'uriageKingaku', align: 'right' },
      { text: '支払金額', value: 'shiharaiUnchin', align: 'right' },
      { text: '支払通行料', value: 'shiharaiHiwayPrice', align: 'right' },
      { text: '（税抜き額）', value: 'shiharaiHiwayPriceZeinuki', align: 'right' },
      { text: '支払い非課税額', value: 'shiharaiKingakuHikazei', align: 'right' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ]
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      usersEigyosho: 'users/eigyoshoCd'
    }),
    // 営業所マスタフィルター --> ここから
    filteredMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstEigyosho.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    filteredMstShiiresakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn !== '03'
      })
    },
    filteredYoshaJininList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn === '03'
      })
    },
    // 人員マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === false
      })
    },
    filteredMstYoshaSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター <-- ここまで
    // 車種フィルター --> ここから
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredNenryoKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    filteredShiharaiShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT021')
    },
    // 車種フィルター <-- ここまで

    // 配送明細データ
    haisoMeisaiRows () {
      // データがない場合の制御
      if (!this.viewsData.vwHaisoMeisai.map) return

      return this.viewsData.vwHaisoMeisai.map((elem) => {
        if (elem.eigyoshoCd) {
          elem.wEigyoshoCdNm = elem.eigyoshoCd + ' : ' + elem.eigyoshoNm
        }
        if (elem.ninushiCd) {
          elem.wNinushiCdNm = elem.ninushiNm ? elem.ninushiCd + ' : ' + elem.ninushiNm : elem.ninushiCd
        }
        if (elem.hatsuchiCd) {
          elem.wHatsuchiCdNm = elem.hatsuchiNm ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiCd
        } else if (elem.hatsuchiNm) {
          elem.wHatsuchiCdNm = elem.hatsuchiNm
        }
        if (elem.oroshisakiCd) {
          elem.wOroshisakiCdNm = elem.oroshisakiNm ? elem.oroshisakiCd + ' : ' + elem.oroshisakiNm : elem.oroshisakiCd
        }
        if (elem.chakuchiCd) {
          elem.wChakuchiCdNm = elem.chakuchiNm ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiCd
        } else if (elem.chakuchiNm) {
          elem.wChakuchiCdNm = elem.chakuchiNm
        }
        if (elem.uriageKingaku) {
          elem.uriageKingaku = filter.numericFormatter(String(elem.uriageKingaku))
        }

        return elem
      })
    },
    // 燃料行データ
    nenryohiRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiNenryohi.map) return

      return this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
        if (elem.torihikisakiCd) {
          elem.wTorihikisakiCdNm = elem.torihikisakiCd !== -1 ? elem.torihikisakiCd + ' : ' + elem.torihikisakiNm : ''
        }
        if (elem.fuelKbn) {
          elem.wFuelKbnNm = elem.fuelKbnNm !== -1 ? elem.fuelKbn + ' : ' + elem.fuelKbnNm : ''
        }
        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + elem.shiharaiKbnNm : ''
        }
        if (elem.suryo) {
          elem.suryo = filter.numericFormatter(String(elem.suryo))
        }
        if (elem.keihiTanka) {
          elem.keihiTanka = filter.numericFormatter(String(elem.keihiTanka))
        }
        if (elem.keihiKingaku) {
          elem.keihiKingaku = filter.numericFormatter(String(elem.keihiKingaku))
        }
        return elem
      })
    },
    // 通行料行データ
    tsukoryoRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiTsukoryo.map) return

      return this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + elem.shiharaiKbnNm : ''
        }

        return elem
      })
    },
    // 傭車配送明細データ
    yoshaHaisoMeisaiRows () {
      // データがない場合の制御
      if (!this.viewsData.vwHaisoMeisai.map) return

      return this.viewsData.vwHaisoMeisai.map((elem) => {
        if (elem.eigyoshoCd) {
          elem.wEigyoshoCdNm = elem.eigyoshoCd + ' : ' + elem.eigyoshoNm
        }
        if (elem.ninushiCd) {
          elem.wNinushiCdNm = elem.ninushiCd + ' : ' + elem.ninushiNm
        }
        if (elem.hatsuchiCd) {
          elem.wHatsuchiCdNm = elem.hatsuchiNm ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiCd
        } else if (elem.hatsuchiNm) {
          elem.wHatsuchiCdNm = elem.hatsuchiNm
        }
        if (elem.oroshisakiCd) {
          elem.wOroshisakiCdNm = elem.oroshisakiNm ? elem.oroshisakiCd + ' : ' + elem.oroshisakiNm : elem.oroshisakiCd
        }
        if (elem.chakuchiCd) {
          elem.wChakuchiCdNm = elem.chakuchiNm ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiCd
        } else if (elem.chakuchiNm) {
          elem.wChakuchiCdNm = elem.chakuchiNm
        }
        if (elem.uriageKingaku) {
          elem.uriageKingaku = filter.numericFormatter(String(elem.uriageKingaku))
        }
        if (elem.shiharaiUnchin) {
          elem.shiharaiUnchin = filter.numericFormatter(String(elem.shiharaiUnchin))
        }
        if (elem.shiharaiHiwayPrice) {
          elem.shiharaiHiwayPrice = filter.numericFormatter(String(elem.shiharaiHiwayPrice))
          elem.shiharaiHiwayPriceZeinuki = filter.numericFormatter(String(this.taxExcludedCalculation(elem.shiharaiHiwayPrice)))
        }
        if (elem.shiharaiKingakuHikazei) {
          elem.shiharaiKingakuHikazei = filter.numericFormatter(String(elem.shiharaiKingakuHikazei))
        }
        return elem
      })
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  watch: {
    'viewsData.vwKintaiJissekiJoshu': {
      handler: function (s) {
        if (s.jininId === '' || s.jininId === null || typeof s.jininId === 'undefined') {
          this.isRequiredJoshu = false
        } else {
          this.isRequiredJoshu = true
        }
      },
      deep: true
    },
    'viewsData.vwUnkoJisseki': {
      handler: function (s) {
        if (this.haishaKbn === '01') {
          // 自社車両分
          if (s.sharyoId === '' || s.sharyoId === null || typeof s.sharyoId === 'undefined') {
            this.jishaSharyoSbt = ''
          } else {
            var jishaSharyo = this.sharyoList.filter((t) => {
              return t.id === s.sharyoId
            })
            if (jishaSharyo.length > 0) {
              this.jishaSharyoSbt = jishaSharyo[0].shashuSbt
            } else {
              this.jishaSharyoSbt = ''
            }
          }
        } else {
          // 傭車車両分
          if (this.yoshaSharyoSbt === '' || this.yoshaSharyoSbt === null) {
            if (s.hacchusakiShaban === '' || s.hacchusakiShaban === null || typeof s.hacchusakiShaban === 'undefined') {
              this.yoshaSharyoSbt = ''
            } else {
              var yoshaSharyo = this.sharyoList.filter((t) => {
                return t.sharyoNo === s.hacchusakiShaban
              })
              if (yoshaSharyo.length > 0) {
                this.yoshaSharyoSbt = yoshaSharyo[0].shashuSbt
              } else {
                this.yoshaSharyoSbt = ''
              }
            }
          }
        }
      },
      deep: true
    },
    haishaKbn: function (n) {
      if (n === '01') {
        this.isRequiredJomuin = true
        if (this.viewsData.vwKintaiJissekiJoshu.jininId === '' || this.viewsData.vwKintaiJissekiJoshu.jininId === null) {
          this.isRequiredJoshu = false
        } else {
          this.isRequiredJoshu = true
        }
        this.isRequiredSharyo = true
        this.isRequiredYosha = false
      } else {
        this.isRequiredJomuin = false
        this.isRequiredJoshu = false
        this.isRequiredSharyo = false
        this.isRequiredYosha = true
      }
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        viewsData: this.viewsData
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    fetchData: function () {
      return new Promise((resolve) => {
        this.conditions.digitakoUnkoId = this.viewsData.vwUnkoJisseki.unkoJissekiNo
        console.log(this.conditions.digitakoUnkoId)
        this.HttpClient
          .post('/api/v1/THPRMD0010/FindByDigitakoUnkoId', this.conditions)
          .then((data) => {
            // /* eslint no-debugger: "warn" */
            // debugger
            if (data.payload.vwUnkoJisseki) {
              if (data.isValid === false) { return this.setInvalidSummaryMessage(data.summaryMessage.messageCd) }

              // ==================================================
              // 運行実績情報
              // ==================================================-
              if (data.payload.vwUnkoJisseki) {
                this.viewsData.vwUnkoJisseki = data.payload.vwUnkoJisseki
                this.haishaKbn = this.viewsData.vwUnkoJisseki.haishaKbn
                this.yoshaSharyoSbt = this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt
                if (this.viewsData.vwUnkoJisseki.unkoYmd) {
                  this.viewsData.vwUnkoJisseki.unkoYmd = filter.dateFormatter(this.viewsData.vwUnkoJisseki.unkoYmd)
                } else {
                  this.viewsData.vwUnkoJisseki.unkoYmd = filter.dateFormatter(new Date())
                }

                // ==================================================
                // 乗務員情報
                // ==================================================
                if (data.payload.vwKintaiJissekiJomuin) {
                  this.viewsData.vwKintaiJissekiJomuin = data.payload.vwKintaiJissekiJomuin
                  if (this.viewsData.vwKintaiJissekiJomuin.shukkinYmd) {
                    this.viewsData.vwKintaiJissekiJomuin.shukkinYmd = filter.dateFormatter(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd)
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.shukkinHms) {
                    this.viewsData.vwKintaiJissekiJomuin.shukkinHms = complements.parseTime(this.viewsData.vwKintaiJissekiJomuin.shukkinHms, false).substr(0, 5)
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.taikinYmd) {
                    this.viewsData.vwKintaiJissekiJomuin.taikinYmd = filter.dateFormatter(this.viewsData.vwKintaiJissekiJomuin.taikinYmd)
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.taikinHms) {
                    this.viewsData.vwKintaiJissekiJomuin.taikinHms = complements.parseTime(this.viewsData.vwKintaiJissekiJomuin.taikinHms, false).substr(0, 5)
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.kosokuJikan !== null) {
                    this.viewsData.vwKintaiJissekiJomuin.kosokuJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJomuin.kosokuJikan))
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan || this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan === 0) {
                    this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan))
                  }
                  if (this.viewsData.vwKintaiJissekiJomuin.kadouJikan !== null) {
                    this.viewsData.vwKintaiJissekiJomuin.kadouJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJomuin.kadouJikan))
                  }
                }

                // ==================================================
                // 助手情報 ※存在時のみ実施
                // ==================================================
                if (data.payload.vwKintaiJissekiJoshu) {
                  this.viewsData.vwKintaiJissekiJoshu = data.payload.vwKintaiJissekiJoshu
                  if (this.viewsData.vwKintaiJissekiJoshu.shukkinYmd) {
                    this.viewsData.vwKintaiJissekiJoshu.shukkinYmd = filter.dateFormatter(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd)
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.shukkinHms) {
                    this.viewsData.vwKintaiJissekiJoshu.shukkinHms = complements.parseTime(this.viewsData.vwKintaiJissekiJoshu.shukkinHms, false).substr(0, 5)
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.taikinYmd) {
                    this.viewsData.vwKintaiJissekiJoshu.taikinYmd = filter.dateFormatter(this.viewsData.vwKintaiJissekiJoshu.taikinYmd)
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.taikinHms) {
                    this.viewsData.vwKintaiJissekiJoshu.taikinHms = complements.parseTime(this.viewsData.vwKintaiJissekiJoshu.taikinHms, false).substr(0, 5)
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.kosokuJikan !== null) {
                    this.viewsData.vwKintaiJissekiJoshu.kosokuJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJoshu.kosokuJikan))
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan || this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan === 0) {
                    this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan))
                  }
                  if (this.viewsData.vwKintaiJissekiJoshu.kadouJikan !== null) {
                    this.viewsData.vwKintaiJissekiJoshu.kadouJikan = this.convertTimeFormat(filter.minToTimeFormatter(this.viewsData.vwKintaiJissekiJoshu.kadouJikan))
                  }
                } else {
                  this.viewsData.vwKintaiJissekiJoshu = {}
                  this.$set(this.viewsData.vwKintaiJissekiJoshu, 'jininId', '')
                }

                // ==================================================
                // 紐づけ済み貨物情報 ※存在時のみ実施
                // ==================================================
                if (data.payload.vwHaisoMeisai) {
                  this.viewsData.vwHaisoMeisai = data.payload.vwHaisoMeisai
                }

                // ==================================================
                // 燃料費 ※存在時のみ実施
                // ==================================================
                if (data.payload.vwSharyoKeihiNenryohi) {
                  this.viewsData.vwSharyoKeihiNenryohi = data.payload.vwSharyoKeihiNenryohi
                }

                // ==================================================
                // 通行料 ※存在時のみ実施
                // ==================================================
                if (data.payload.vwSharyoKeihiTsukoryo) {
                  this.viewsData.vwSharyoKeihiTsukoryo = data.payload.vwSharyoKeihiTsukoryo
                }

                // ==================================================
                // 権限制御
                // ==================================================
                this.isReadOnlyBase = true
              }

              // 複写ボタン押下時
              if (this.copyMode === 1) {
                this.viewsData.vwUnkoJisseki.id = -1
                this.viewsData.vwUnkoJisseki.unkoJissekiNo = ''
                this.viewsData.vwUnkoJisseki.trSagyoJissekiId = -1
                this.viewsData.vwKintaiJissekiJomuin.id = -1
                this.viewsData.vwKintaiJissekiJoshu.id = -1
                this.viewsData.vwHaisoMeisai = []
                this.viewsData.vwSharyoKeihiNenryohi = []
                this.viewsData.vwSharyoKeihiTsukoryo = []
                this.DeleteButtonDisp = false
                this.NewButtonDisp = true
                this.isReadOnlyBase = false
                this.isReadOnlyCommon = false
                this.isReadOnlyJisha = false
                this.isReadOnlyYosha = false
                this.$refs.unkoJissekiNo.innerValue = null
              // 通常時
              } else if (this.copyMode === 0) {
                if (this.viewsData.vwUnkoJisseki.id === 0) {
                  // 新規モード
                  this.modeOfEdit = 0
                } else {
                  // 更新モード
                  this.modeOfEdit = 1
                }

                if (this.modeKengen === 2 && this.modeOfEdit === 1) {
                  this.DeleteButtonDisp = true
                } else {
                  this.DeleteButtonDisp = false
                }

                if (this.modeOfEdit !== 0) {
                  this.NewButtonDisp = true
                } else {
                  this.NewButtonDisp = false
                }
              }
              if (this.registerMode !== 1) {
                this.clearSummaryMessage()
              }
              this.copyMode = 0
              this.clearInvalidMessage(this.$refs)
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            } else {
              this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMI0101'))
            }
            resolve()
          })
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 初期表示
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'mstjinin', 'mstshubetsu', 'vwcmsteigyoshojininlist', 'vwcmstsharyo', 'msyskubun'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.modeKengen === 0) {
              self.SaveButtonDisp = false
            }

            resolve()
          })
        },
        requestApiPromise: this.fetchData
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * フッターボタンイベント
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.viewsData = self.cloneData.viewsData
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            var viewsData = self.cloneData.viewsData
            // DB処理用変換
            if (viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
              self.viewsData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJomuin.kosokuJikan)
            }
            if (viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
              self.viewsData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJomuin.kyukeiJikan)
            }
            if (viewsData.vwKintaiJissekiJomuin.kadouJikan) {
              self.viewsData.vwKintaiJissekiJomuin.kadouJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJomuin.kadouJikan)
            }
            if (viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
              self.viewsData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJoshu.kosokuJikan)
            }
            if (viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
              self.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
            }
            if (viewsData.vwKintaiJissekiJoshu.kadouJikan) {
              self.viewsData.vwKintaiJissekiJoshu.kadouJikan = filter.timeToMinFormatter(viewsData.vwKintaiJissekiJoshu.kadouJikan)
            }
            if (viewsData.vwHaisoMeisai) {
              self.viewsData.vwHaisoMeisai = viewsData.vwHaisoMeisai.map((elem) => {
                elem.uriageKingaku = this.removeComma(elem.uriageKingaku)
                elem.shiharaiUnchin = this.removeComma(elem.shiharaiUnchin)
                elem.shiharaiHiwayPrice = this.removeComma(elem.shiharaiHiwayPrice)
                elem.shiharaiKingakuHikazei = this.removeComma(elem.shiharaiKingakuHikazei)
                return elem
              })
            }

            self.HttpClient.post('/api/v1/THPRMD0010/Delete', self.viewsData).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return true
        },
        settingReloadWindow: function () {
          return true
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 新規ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onNewButtonClick: function (e) {
      const p = modals.showConfirm
      this.Effects.loadStart()
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.initialize()
        this.initBindVariables()
        // this.transition(1, { id: 0 }, this.initialize)
        this.isReadOnlyBase = false
        this.isReadOnlyCommon = false
        this.isReadOnlyJisha = false
        this.isReadOnlyYosha = false
        this.DeleteButtonDisp = false
        this.NewButtonDisp = true
      })
      this.Effects.loadComplete()
    },
    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      this.copyMode = 1
      // this.$refs.unkoJissekiNo.onDialogButtonClick()
      if (this.viewsData.vwUnkoJisseki.id <= 0 || !this.viewsData.vwUnkoJisseki.id) {
        return this.$refs.unkoJissekiNo.onDialogButtonClick()
      }
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.changeNippoNo(this.viewsData.vwUnkoJisseki.unkoJissekiNo)
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            // /* eslint no-debugger: "warn" */
            // debugger
            self.viewsData.vwUnkoJisseki.id = data.payload.vwUnkoJisseki.id
            self.viewsData.vwUnkoJisseki.unkoJissekiNo = data.payload.vwUnkoJisseki.unkoJissekiNo
            self.registerMode = 1
            this.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.viewsData.vwUnkoJisseki.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.viewsData.vwUnkoJisseki.unkoJissekiNo }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 日報No反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    changeNippoNoFromDialog: function (p) {
      console.log(' **** XXXXX **** changeNippoNoFromDialog', p)
      this.viewsData.vwUnkoJisseki.unkoJissekiNo = p
      this.fetchData()
    },
    changeNippoNo: function (p) {
      console.log(' **** XXXXX **** changeNippoNo', p)
      this.fetchData()
    },
    // ----------------------------------------------------------------------------------------------------
    // 日報検索
    // ----------------------------------------------------------------------------------------------------
    onNippoSearchCloseButtonClick: function () {
      this.nippo_search_dialog = false
    },
    onNippoSearchSaveButtonClick: function () {
      this.nippo_search_dialog = false
    },
    // ----------------------------------------------------------------------------------------------------
    // 紐付け貨物検索
    // ----------------------------------------------------------------------------------------------------
    onKamotsuSyncOffButtonClick: function (item) {
      const index = this.viewsData.vwHaisoMeisai.indexOf(item)
      this.recHaisoMeisai = Object.assign({}, item)
      this.recHaisoMeisai.editFlg = true
      this.recHaisoMeisai.delFlg = !this.recHaisoMeisai.delFlg
      Object.assign(this.viewsData.vwHaisoMeisai[index], this.recHaisoMeisai)
    },
    kamotsuSync: function (p) {
      // console.log(' **** XXXXX **** kamotsuSync', p)
      // /* eslint no-debugger: "warn" */
      // debugger
      for (let i = 0; i < p.length; i++) {
        const res = this.viewsData.vwHaisoMeisai.find((v) => v.trSagyoMeisaiId === p[i].id)
        if (res) { continue }

        this.recHaisoMeisai.id = -1
        if (p[i].sjsrId) {
          this.recHaisoMeisai.id = p[i].sjsrId
        }
        this.recHaisoMeisai.editFlg = true
        this.recHaisoMeisai.delFlg = false
        this.recHaisoMeisai.trSagyoMeisaiId = p[i].id
        this.recHaisoMeisai.trJuchuKihonId = p[i].trJuchuKihonId
        this.recHaisoMeisai.trJuchuMeisaiId = p[i].trJuchuMeisaiId
        this.recHaisoMeisai.juchuNo = p[i].juchuNo
        if (this.viewsData.vwUnkoJisseki) {
          this.recHaisoMeisai.trUnkoJissekiId = this.viewsData.vwUnkoJisseki.id
          this.recHaisoMeisai.trSagyoJissekiId = this.viewsData.vwUnkoJisseki.trSagyoJissekiId
        } else {
          this.recHaisoMeisai.trUnkoJissekiId = -1
          this.recHaisoMeisai.trSagyoJissekiId = -1
        }
        this.recHaisoMeisai.juchuEigyoshoId = p[i].eigyoshoId
        this.recHaisoMeisai.eigyoshoCd = p[i].eigyoshoCd
        this.recHaisoMeisai.eigyoshoNm = p[i].eigyoshoNm
        this.recHaisoMeisai.ninushiId = p[i].ninushiId
        this.recHaisoMeisai.ninushiCd = p[i].ninushiCd
        this.recHaisoMeisai.ninushiNm = p[i].ninushiNm
        this.recHaisoMeisai.hatsuchiId = p[i].hatsuchiId
        this.recHaisoMeisai.hatsuchiCd = p[i].hatsuchiCd
        this.recHaisoMeisai.hatsuchiNm = p[i].hatsuchiNm
        this.recHaisoMeisai.oroshisakiId = p[i].oroshisakiId
        this.recHaisoMeisai.oroshisakiCd = p[i].oroshisakiCd
        this.recHaisoMeisai.oroshisakiNm = p[i].oroshisakiNm
        this.recHaisoMeisai.chakuchiId = p[i].chakuchiId
        this.recHaisoMeisai.chakuchiCd = p[i].chakuchiCd
        this.recHaisoMeisai.chakuchiNm = p[i].chakuchiNm
        this.recHaisoMeisai.uriageKingaku = p[i].uriageKingaku
        this.recHaisoMeisai.updDate = p[i].updDate
        if (p[i].sjsrUpdDate) {
          this.recHaisoMeisai.sjsrUpdDate = p[i].sjsrUpdDate
        }
        // 表示用編集
        this.recHaisoMeisai.wEigyoshoCdNm = this.recHaisoMeisai.eigyoshoCd + ' : ' + this.recHaisoMeisai.eigyoshoNm
        if (this.recHaisoMeisai.ninushiCd) {
          this.recHaisoMeisai.wNinushiCdNm = this.recHaisoMeisai.ninushiNm ? this.recHaisoMeisai.ninushiCd + ' : ' + this.recHaisoMeisai.ninushiNm : this.recHaisoMeisai.ninushiCd
        }
        if (this.recHaisoMeisai.hatsuchiCd) {
          this.recHaisoMeisai.wHatsuchiCdNm = this.recHaisoMeisai.hatsuchiNm ? this.recHaisoMeisai.hatsuchiCd + ' : ' + this.recHaisoMeisai.hatsuchiNm : this.recHaisoMeisai.hatsuchiCd
        } else if (this.recHaisoMeisai.hatsuchiNm) {
          this.recHaisoMeisai.wHatsuchiCdNm = this.recHaisoMeisai.hatsuchiNm
        }
        if (this.recHaisoMeisai.oroshisakiCd) {
          this.recHaisoMeisai.wOroshisakiCdNm = this.recHaisoMeisai.oroshisakiNm ? this.recHaisoMeisai.oroshisakiCd + ' : ' + this.recHaisoMeisai.oroshisakiNm : this.recHaisoMeisai.oroshisakiCd
        }
        if (this.recHaisoMeisai.chakuchiCd) {
          this.recHaisoMeisai.wChakuchiCdNm = this.recHaisoMeisai.chakuchiNm ? this.recHaisoMeisai.chakuchiCd + ' : ' + this.recHaisoMeisai.chakuchiNm : this.recHaisoMeisai.chakuchiCd
        } else if (this.recHaisoMeisai.chakuchiNm) {
          this.recHaisoMeisai.wChakuchiCdNm = this.recHaisoMeisai.chakuchiNm
        }
        this.recHaisoMeisai.uriageKingaku = filter.numericFormatter(String(this.recHaisoMeisai.uriageKingaku))
        if (p[i].jhsrId) {
          this.recHaisoMeisai.jhsrId = p[i].jhsrId
        }
        if (p[i].jhsrUpdDate) {
          this.recHaisoMeisai.jhsrUpdDate = p[i].jhsrUpdDate
        }
        this.recHaisoMeisai.trHacchuKihonId = p[i].trHacchuKihonId
        this.recHaisoMeisai.trHacchuMeisaiId = p[i].trHacchuMeisaiId
        this.recHaisoMeisai.shiharaiUnchin = 0
        this.recHaisoMeisai.shiharaiHiwayPrice = 0
        this.$set(this.recHaisoMeisai, 'shiharaiHiwayPriceZeinuki', '0')
        this.recHaisoMeisai.shiharaiKingakuHikazei = 0

        if (this.viewsData.vwHaisoMeisai.length > 0) {
          this.viewsData.vwHaisoMeisai.push(this.recHaisoMeisai)
        } else {
          this.viewsData.vwHaisoMeisai = [this.recHaisoMeisai]
        }
        this.recHaisoMeisai = Object.assign({}, this.recHaisoMeisaiDefault)
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 燃料編集
    // ----------------------------------------------------------------------------------------------------
    onNenryoEditNewButtonClick: function () {
      this.$modal.show('nenryo-edit-dialog')
    },
    onNenryoEditOpenButtonClick: function (item) {
      this.nenryo_edit_index = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
      this.recNenryo = Object.assign({}, item)
      this.$modal.show('nenryo-edit-dialog')
    },
    onNenryoEditDeleteButtonClick: function (item) {
      const index = this.viewsData.vwSharyoKeihiNenryohi.indexOf(item)
      this.recNenryo = Object.assign({}, item)
      this.recNenryo.editFlg = true
      this.recNenryo.delFlg = !this.recNenryo.delFlg
      Object.assign(this.viewsData.vwSharyoKeihiNenryohi[index], this.recNenryo)
    },
    onNenryoEditCloseButtonClick: function () {
      this.$modal.hide('nenryo-edit-dialog')
      this.$nextTick(() => {
        this.recNenryo = Object.assign({}, null)
        this.recNenryo.torihikisakiId = null
        this.nenryo_edit_index = -1
      })
    },
    onNenryoEditSaveButtonClick: function () {
      if (this.nenryo_edit_index > -1) {
        this.recNenryo.editFlg = true
        Object.assign(this.viewsData.vwSharyoKeihiNenryohi[this.nenryo_edit_index], this.recNenryo)
        this.onNenryoEditCloseButtonClick()
      } else {
        this.recNenryo.id = -1
        this.recNenryo.editFlg = true
        this.recNenryo.delFlg = false

        // 取引先名称
        this.recNenryo.torihikisakiCd = this.getTorihikisakiCd(this.recNenryo.torihikisakiId)
        this.recNenryo.torihikisakiNm = this.getTorihikisakiNm(this.recNenryo.torihikisakiId)
        this.recNenryo.wTorihikisakiCdNm = this.recNenryo.torihikisakiCd !== -1 ? this.recNenryo.torihikisakiCd + ' : ' + this.recNenryo.torihikisakiNm : ''
        // 燃料区分
        this.recNenryo.fuelKbnNm = this.getKubunNm('SFF053', this.recNenryo.fuelKbn)
        this.recNenryo.wFuelKbnNm = this.recNenryo.fuelKbnNm !== -1 ? this.recNenryo.fuelKbn + ' : ' + this.recNenryo.fuelKbnNm : ''
        // 支払種別
        this.recNenryo.shiharaiKbnNm = this.getShubetsuNm('SBT021', this.recNenryo.tekiyo3)
        this.recNenryo.wShiharaiKbnNm = this.recNenryo.shiharaiKbnNm !== -1 ? this.recNenryo.tekiyo3 + ' : ' + this.recNenryo.shiharaiKbnNm : ''

        if (this.viewsData.vwSharyoKeihiNenryohi.length > 0) {
          this.viewsData.vwSharyoKeihiNenryohi.push(this.recNenryo)
        } else {
          // var targetRow = JSON.parse(JSON.stringify(this.recNenryo))
          this.viewsData.vwSharyoKeihiNenryohi = [this.recNenryo]
        }
      }
      this.recNenryo = Object.assign({}, this.recKeihiDefault)
    },
    // ----------------------------------------------------------------------------------------------------
    // 通行料編集
    // ----------------------------------------------------------------------------------------------------
    onTsukoryoEditNewButtonClick: function () {
      this.$modal.show('tsukoryo-edit-dialog')
    },
    onTsukoryoEditOpenButtonClick: function (item) {
      this.tsukoryo_edit_index = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
      this.recTsukoryo = Object.assign({}, item)
      this.$modal.show('tsukoryo-edit-dialog')
    },
    onTsukoryoEditDeleteButtonClick: function (item) {
      const index = this.viewsData.vwSharyoKeihiTsukoryo.indexOf(item)
      this.recTsukoryo = Object.assign({}, item)
      this.recTsukoryo.editFlg = true
      this.recTsukoryo.delFlg = !this.recTsukoryo.delFlg
      Object.assign(this.viewsData.vwSharyoKeihiTsukoryo[index], this.recTsukoryo)
    },
    onTsukoryoEditCloseButtonClick: function () {
      this.$modal.hide('tsukoryo-edit-dialog')
      this.$nextTick(() => {
        this.recTsukoryo = Object.assign({}, null)
        this.recTsukoryo.torihikisakiId = null
        this.tsukoryo_edit_index = -1
      })
    },
    onTsukoryoEditSaveButtonClick: function () {
      if (this.tsukoryo_edit_index > -1) {
        this.recTsukoryo.editFlg = true
        Object.assign(this.viewsData.vwSharyoKeihiTsukoryo[this.tsukoryo_edit_index], this.recTsukoryo)
        this.onTsukoryoEditCloseButtonClick()
      } else {
        this.recTsukoryo.id = -1
        this.recTsukoryo.editFlg = true
        this.recTsukoryo.delFlg = false
        // 支払種別
        if (this.recTsukoryo.tekiyo3 !== undefined && this.recTsukoryo.tekiyo3 !== '' && this.recTsukoryo.tekiyo3 !== null) {
          this.recTsukoryo.shiharaiKbnNm = this.getShubetsuNm('SBT021', this.recTsukoryo.tekiyo3)
          this.recTsukoryo.wShiharaiKbnNm = this.recTsukoryo.tekiyo3 + ' : ' + this.recTsukoryo.shiharaiKbnNm
        } else {
          this.recTsukoryo.wShiharaiKbnNm = ''
        }
        if (this.viewsData.vwSharyoKeihiTsukoryo.length > 0) {
          this.viewsData.vwSharyoKeihiTsukoryo.push(this.recTsukoryo)
        } else {
          // var targetRow = JSON.parse(JSON.stringify(this.recNenryo))
          this.viewsData.vwSharyoKeihiTsukoryo = [this.recTsukoryo]
        }
      }
      this.recTsukoryo = Object.assign({}, this.recKeihiDefault)
    },
    // ----------------------------------------------------------------------------------------------------
    // 支払い運賃編集
    // ----------------------------------------------------------------------------------------------------
    shiharaiUnchinSaved (e, row) {
      if (!e) { return false }

      const shiharaiUnchin = this.removeComma(e)
      if (!window.isFinite(shiharaiUnchin)) { return }
      row.shiharaiUnchin = filter.numericFormatter(shiharaiUnchin)
      row.editFlg = true
    },
    // ----------------------------------------------------------------------------------------------------
    // 支払い通行料税抜き額編集
    // ----------------------------------------------------------------------------------------------------
    shiharaiHiwayPriceSaved (e, row) {
      if (!e) { return false }

      const shiharaiHaywayPrice = this.removeComma(e)
      if (!window.isFinite(shiharaiHaywayPrice)) { return }
      row.shiharaiHiwayPrice = filter.numericFormatter(shiharaiHaywayPrice)
      row.shiharaiHiwayPriceZeinuki = filter.numericFormatter(String(this.taxExcludedCalculation(shiharaiHaywayPrice)))
      row.editFlg = true
    },
    // ----------------------------------------------------------------------------------------------------
    // 支払い非課税額編集
    // ----------------------------------------------------------------------------------------------------
    shiharaiKingakuHikazeiSaved (e, row) {
      if (!e) { return false }

      const shiharaiKingakuHikazei = this.removeComma(e)
      if (!window.isFinite(shiharaiKingakuHikazei)) { return }
      row.shiharaiKingakuHikazei = filter.numericFormatter(shiharaiKingakuHikazei)
      row.editFlg = true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.id = 0
      this.haishaKbn = '01'
      this.jishaSharyoSbt = ''
      this.yoshaSharyoSbt = ''
      this.viewsData.vwUnkoJisseki = {}
      this.$set(this.viewsData.vwUnkoJisseki, 'sharyoId', '')
      this.$refs.unkoYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.viewsData.vwKintaiJissekiJomuin = {}
      this.viewsData.vwKintaiJissekiJoshu = {}
      this.$set(this.viewsData.vwKintaiJissekiJoshu, 'jininId', '')
      this.viewsData.vwHaisoMeisai = []
      this.viewsData.vwSharyoKeihiNenryohi = []
      this.viewsData.vwSharyoKeihiTsukoryo = []
      this.$set(this.viewsData.vwUnkoJisseki, 'hacchusakiShaban', '')

      // dd-code-text-boxにbindしている項目は明示的にNullを設定する事
      this.viewsData.vwUnkoJisseki.eigyoshoId = this.getEigyoshoId(this.usersEigyosho)
      this.viewsData.vwUnkoJisseki.sharyoId = null
      this.viewsData.vwKintaiJissekiJomuin.jininId = null
      this.viewsData.vwKintaiJissekiJoshu.jininId = null
      this.viewsData.vwUnkoJisseki.hacchusakiId = null
      this.viewsData.vwUnkoJisseki.hacchusakiJomuinId = null

      this.copyMode = 0
      this.registerMode = 0

      // 権限制御
      this.isReadOnlyBase = false
      this.isReadOnlyCommon = false
      this.isReadOnlyJisha = false
      this.isReadOnlyYosha = false
    },
    registerPromise: function () {
      const self = this
      // DB処理用変換
      this.viewsData.vwUnkoJisseki.haishaKbn = this.haishaKbn
      this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt = this.yoshaSharyoSbt
      if (this.viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
        self.viewsData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJomuin.kosokuJikan)
      }
      if (this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
        self.viewsData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)
      }
      if (this.viewsData.vwKintaiJissekiJomuin.kadouJikan) {
        self.viewsData.vwKintaiJissekiJomuin.kadouJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJomuin.kadouJikan)
      }
      if (this.viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
        self.viewsData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJoshu.kosokuJikan)
      }
      if (this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
        self.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
      }
      if (this.viewsData.vwKintaiJissekiJoshu.kadouJikan) {
        self.viewsData.vwKintaiJissekiJoshu.kadouJikan = filter.timeToMinFormatter(this.viewsData.vwKintaiJissekiJoshu.kadouJikan)
      }
      if (this.viewsData.vwHaisoMeisai) {
        self.viewsData.vwHaisoMeisai = this.viewsData.vwHaisoMeisai.map((elem) => {
          elem.uriageKingaku = this.removeComma(elem.uriageKingaku)
          elem.shiharaiUnchin = this.removeComma(elem.shiharaiUnchin)
          elem.shiharaiHiwayPrice = this.removeComma(elem.shiharaiHiwayPrice)
          elem.shiharaiKingakuHikazei = this.removeComma(elem.shiharaiKingakuHikazei)
          return elem
        })
      }
      // 登録/更新処理実行
      return this.HttpClient.post('/api/v1/THPRMD0010/Create', self.viewsData)
    },
    // 登録前チェック
    registerValidate: function () {
      if (this.viewsData.vwUnkoJisseki.id > 0 && this.viewsData.vwUnkoJisseki.unkoJissekiNo !== this.cloneData.viewsData.vwUnkoJisseki.unkoJissekiNo) {
        this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121'))
        this.setInvalidSummaryMessage('PRME0001')
        return false
      }

      if (!this.calcJomuinKosokuJikan()) return false
      if (!this.calcJomuinKadouJikan()) return false
      if (!this.calcJoshuKosokuJikan()) return false
      if (!this.calcJoshuKadouJikan()) return false
      if (!this.calcSokoKyori()) return false
      if (!this.calcJisshaKyori()) return false

      return true
    },
    // データ取得
    getEigyoshoId: function (pEigyoshoCd) {
      const target = filter.dateFormatter(new Date())
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.eigyoshoCd === pEigyoshoCd && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].id
      }
      return ''
    },
    getTorihikisakiCd: function (pTorihikisakiId) {
      var torihikisaki = this.torihikisakiList.filter((t) => {
        return t.id === pTorihikisakiId
      })
      if (torihikisaki.length > 0) {
        return torihikisaki[0].torihikisakiCd
      }
      return -1
    },
    getTorihikisakiNm: function (pTorihikisakiId) {
      var torihikisaki = this.torihikisakiList.filter((t) => {
        return t.id === pTorihikisakiId
      })
      if (torihikisaki.length > 0) {
        return torihikisaki[0].torihikisakiNm
      }
      return -1
    },
    getShubetsuNm: function (pSbtShuruiCd, pSbtCd) {
      var shubetsu = this.shubetsuList.filter((t) => {
        return t.sbtShuruiCd === pSbtShuruiCd && t.sbtCd === pSbtCd
      })
      if (shubetsu.length > 0) {
        return shubetsu[0].sbtNm
      }
      return -1
    },
    getKubunNm: function (pSbtKubunCd, pKbnCd) {
      var kubun = this.kubunList.filter((t) => {
        return t.kbnShuruiCd === pSbtKubunCd && t.code === pKbnCd
      })
      if (kubun.length > 0) {
        return kubun[0].codeNm
      }
      return -1
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 時間計算
    // * ToとFromの差を分で返す
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    calcJomuinKosokuJikan: function () {
      var msg
      if (this.viewsData.vwKintaiJissekiJomuin.shukkinYmd && this.viewsData.vwKintaiJissekiJomuin.taikinYmd) {
        msg = validators.compareDate(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd, this.viewsData.vwKintaiJissekiJomuin.taikinYmd)
        if (msg !== undefined) {
          this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwKintaiJissekiJomuin.shukkinYmd && this.viewsData.vwKintaiJissekiJomuin.shukkinHms && this.viewsData.vwKintaiJissekiJomuin.taikinYmd && this.viewsData.vwKintaiJissekiJomuin.taikinHms) {
        msg = validators.compareDateTime(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd, this.viewsData.vwKintaiJissekiJomuin.shukkinHms, this.viewsData.vwKintaiJissekiJomuin.taikinYmd, this.viewsData.vwKintaiJissekiJomuin.taikinHms)
        if (msg !== undefined) {
          this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukkinHms1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinHms1[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      var diffMin = this.calcDiffMinByYmdHms(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd, this.viewsData.vwKintaiJissekiJomuin.shukkinHms, this.viewsData.vwKintaiJissekiJomuin.taikinYmd, this.viewsData.vwKintaiJissekiJomuin.taikinHms)
      if (diffMin !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kosokuJikan', filter.minToTimeFormatter(diffMin))
        this.calcJomuinKadouJikan()
      }
      this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.shukkinHms1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.taikinHms1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kosokuJikan1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kyukeiJikan1[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kadouJikan1[this.Ctrls.SET_INVALID_METHOD]('')

      return true
    },
    calcJomuinKadouJikan: function () {
      if (!(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)) return true
      var kyukeiJikan = this.convertTimeFormat(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)
      if (kyukeiJikan !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kyukeiJikan', kyukeiJikan)
      }
      var diffMin = this.calcDiffMinByHms(this.viewsData.vwKintaiJissekiJomuin.kosokuJikan, kyukeiJikan)
      if (diffMin !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kadouJikan', filter.minToTimeFormatter(diffMin))
      }
      return true
    },
    calcJoshuKosokuJikan: function () {
      var msg
      if (this.viewsData.vwKintaiJissekiJoshu.shukkinYmd && this.viewsData.vwKintaiJissekiJoshu.taikinYmd) {
        msg = validators.compareDate(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd, this.viewsData.vwKintaiJissekiJoshu.taikinYmd)
        if (msg !== undefined) {
          this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwKintaiJissekiJoshu.shukkinYmd && this.viewsData.vwKintaiJissekiJoshu.shukkinHms && this.viewsData.vwKintaiJissekiJoshu.taikinYmd && this.viewsData.vwKintaiJissekiJoshu.taikinHms) {
        msg = validators.compareDateTime(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd, this.viewsData.vwKintaiJissekiJoshu.shukkinHms, this.viewsData.vwKintaiJissekiJoshu.taikinYmd, this.viewsData.vwKintaiJissekiJoshu.taikinHms)
        if (msg !== undefined) {
          this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukkinHms2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinHm2[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      var diffMin = this.calcDiffMinByYmdHms(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd, this.viewsData.vwKintaiJissekiJoshu.shukkinHms, this.viewsData.vwKintaiJissekiJoshu.taikinYmd, this.viewsData.vwKintaiJissekiJoshu.taikinHms)
      if (diffMin !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kosokuJikan', filter.minToTimeFormatter(diffMin))
        this.calcJoshuKadouJikan()
      }
      this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.shukkinHms2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.taikinHms2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kosokuJikan2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kyukeiJikan2[this.Ctrls.SET_INVALID_METHOD]('')
      this.$refs.kadouJikan2[this.Ctrls.SET_INVALID_METHOD]('')

      return true
    },
    calcJoshuKadouJikan: function () {
      if (!(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)) return true
      var kyukeiJikan = this.convertTimeFormat(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
      if (kyukeiJikan !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kyukeiJikan', kyukeiJikan)
      }
      var diffMin = this.calcDiffMinByHms(this.viewsData.vwKintaiJissekiJoshu.kosokuJikan, this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
      if (diffMin !== '') {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kadouJikan', filter.minToTimeFormatter(diffMin))
      }
      return true
    },
    /*
     * 日付＆年月日を渡して経過時間（分）を取得する
     */
    calcDiffMinByYmdHms: function (fromYmd, fromHms, toYmd, toHms) {
      if (!(fromYmd) || !(fromHms) || !(toYmd) || !(toHms)) return ''
      if (fromYmd.length !== 10 || fromHms.length !== 5 || toYmd.length !== 10 || toHms.length !== 5) return ''

      var fromDate = fromYmd.replace(/\//g, '-') + 'T' + fromHms + ':00Z'
      var toDate = toYmd.replace(/\//g, '-') + 'T' + toHms + ':00Z'
      var dtFromDate = dayjs(fromDate)
      var dtToDate = dayjs(toDate)
      // diffの結果がミリ秒なので1000で除算し、その後分に変換
      return dtToDate.diff(dtFromDate, 'm')
    },
    /*
     * 時間から所要時間（分）を計算する
     */
    calcDiffMinByHms: function (fromHms, toHms) {
      if (!(fromHms) || !(toHms)) return ''
      if (fromHms.length !== 5 || toHms.length !== 5) return ''

      var fromMin = filter.timeToMinFormatter(fromHms)
      var toMin = filter.timeToMinFormatter(toHms)

      return fromMin - toMin
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 距離計算
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    calcSokoKyori: function () {
      var msg
      if ((this.viewsData.vwUnkoJisseki.hatsuchiOdoMater) && (this.viewsData.vwUnkoJisseki.chakuchiOdoMater)) {
        msg = validators.compareNumerical(this.viewsData.vwUnkoJisseki.hatsuchiOdoMater, this.viewsData.vwUnkoJisseki.chakuchiOdoMater)
        if (msg !== undefined) {
          this.$refs.hatsuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$set(this.viewsData.vwUnkoJisseki, 'sokoKyori', this.viewsData.vwUnkoJisseki.chakuchiOdoMater - this.viewsData.vwUnkoJisseki.hatsuchiOdoMater)
      }
      return true
    },
    calcJisshaKyori: function () {
      var msg
      if ((this.viewsData.vwUnkoJisseki.sokoKyori) && (this.viewsData.vwUnkoJisseki.kushaKyori)) {
        msg = validators.compareNumerical(this.viewsData.vwUnkoJisseki.kushaKyori, this.viewsData.vwUnkoJisseki.sokoKyori)
        if (msg !== undefined) {
          this.$refs.sokoKyori[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.kushaKyori[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
        this.$set(this.viewsData.vwUnkoJisseki, 'jisshaKyori', this.viewsData.vwUnkoJisseki.sokoKyori - this.viewsData.vwUnkoJisseki.kushaKyori)
      }
      return true
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 別途共通関数待
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    convertTimeFormat: function (timeStr) {
      // /* eslint no-debugger: "warn" */
      // debugger
      if (timeStr.indexOf(':') === -1) {
        timeStr = '0:' + timeStr
      }
      return complements.parseTime(timeStr, true).substr(0, 5)
    },
    row_color_class: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    removeComma: function (num) {
      if (!num) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // 税抜き計算
    taxExcludedCalculation (data) {
      // 通行料が入力されていない場合
      if (data === undefined || data === '') { return 0 }
      if (data === 0) { return 0 }

      const zeinukiKingaku = tax.calcWithoutTax5u6d(data, new Date())

      return zeinukiKingaku
    }
  }
}
